// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gh-menuDrop{max-width:1000px;box-shadow:0 8px 20px rgba(30,61,111,.08);display:flex}.gh-description{padding:2rem;width:40%;--bg-opacity:1;background-color:#f7f7f7;background-color:rgba(247,247,247,var(--bg-opacity))}.gh-content{width:60%;--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}", ""]);
// Exports
module.exports = exports;
